// extracted by mini-css-extract-plugin
export var breakpointXs = "550px";
export var colorGray = "#8e9287";
export var colorGrayDark = "#616161";
export var colorGrayDarker = "#272824";
export var colorGrayLight = "#e3e4e2";
export var colorGrayLighter = "#f2f3f2";
export var colorPrimary = "#a6ce3c";
export var colorSecondary = "#4f7802";
export var h1 = "Headings-module--h1--5e28a";
export var h2 = "Headings-module--h2--306f2";
export var h3 = "Headings-module--h3--54baa";
export var h4 = "Headings-module--h4--f7fff";
export var h5 = "Headings-module--h5--f1d80";
export var h6 = "Headings-module--h6--84fb7";
export var spacingLg = "32px";
export var spacingMd = "32px";
export var spacingSm = "16px";
export var spacingXl = "128px";
export var spacingXs = "8px";
export var spacingXxs = "4px";